module.exports = __webpack_public_path__ + "img/goods4_3.fe01de11.jpg";